import { BaseService } from "./BaseService";
import { IReservationService } from "./interfaces/IReservationService";
import {
  AppendBookingNoteDto,
  BulkUpdateReservationsRequest,
  CreateReservationRequest,
  Reservation,
  ReservationFilters,
  ReservationResponse,
  ReservationStats,
  UpdateReservationRequest,
} from "@/types/reservation";

class ReservationService extends BaseService implements IReservationService {
  private basePath = "/bookings";

  constructor() {
    super();
  }
  getReservationById(id: string): Promise<Reservation> {
    return this.get<Reservation>(`${this.basePath}/${id}`);
  }
  createReservation(data: CreateReservationRequest): Promise<Reservation> {
    return this.post<Reservation>(this.basePath, data);
  }
  updateReservation(
    id: string,
    request: UpdateReservationRequest,
  ): Promise<Reservation> {
    return this.put<Reservation>(`${this.basePath}/${id}`, request);
  }

  appendBookingNote(
    id: string,
    body: AppendBookingNoteDto,
  ): Promise<Reservation> {
    return this.post<Reservation>(`${this.basePath}/${id}/notes`, body);
  }
  bulkUpdateReservations(
    request: BulkUpdateReservationsRequest,
  ): Promise<Reservation[]> {
    return this.patch<Reservation[]>(`${this.basePath}/bulk`, request);
  }
  deleteReservation(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
  getReservationStats(): Promise<ReservationStats> {
    throw new Error("Method not implemented.");
  }
  getReservationsByHotel(): Promise<Reservation[]> {
    throw new Error("Method not implemented.");
  }

  async getReservations(
    page?: number,
    limit?: number,
    filters?: ReservationFilters,
  ): Promise<ReservationResponse> {
    const { dateRange, ...restFilter } = filters || {};

    const reservationFilters = {
      ...restFilter,
      startDate: dateRange?.from
        ? new Date(dateRange?.from).toISOString()
        : null,
      endDate: dateRange?.to ? new Date(dateRange.to).toISOString() : null,
      page,
      limit,
    };
    return this.get<ReservationResponse>(this.basePath, reservationFilters);
  }

  async getReservationsByRoom(
    hotelId: string,
    roomId: string,
  ): Promise<Reservation[]> {
    if (!roomId) return [];

    return this.get<Reservation[]>(this.basePath + "/by-room", {
      hotelId,
      roomId,
    });
  }

  async getReservationsByGuest(
    hotelId: string,
    guestId: string,
  ): Promise<Reservation[]> {
    if (!guestId) return [];

    return this.get<Reservation[]>(this.basePath + "/by-guest", {
      hotelId,
      guestId,
    });
  }
}

export const reservationService = new ReservationService();
